import type { ContactType } from '@mwl/core-lib';

import MailIcon from '@public/assets/contacts/icons/mail.svg';
import PhoneIcon from '@public/assets/contacts/icons/phone.svg';

export const linkPrefixes: Partial<Record<ContactType, string>> = {
  email: 'mailto:',
  phone: 'tel:',
  link: 'mailto:',
};

export const iconByTypeMap = {
  email: MailIcon,
  phone: PhoneIcon,
  link: MailIcon,
  telegram: null,
};
